export const HOSTED_IMAGE_SERVER_RESOURCE = 'https://hosted-images-newsbrief.s3.amazonaws.com'
export const IMAGE_SERVER_RESOURCE = 'https://image-api.rasa.io/image/path/hosted-images-newsbrief/path'
